import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

export default function TopHypercasual() {
  return (
    <div className="min-h-screen px-6 py-12 bg-[#0d0d1a] text-[#e0f7fa]">
      <Helmet>
        <title>Top Hypercasual Games Online - BrowserArena</title>
        <meta
          name="description"
          content="Play top hypercasual browser games instantly. Enjoy quick, addictive games with no downloads—perfect for short breaks and endless fun on BrowserArena."
        />
      </Helmet>

      <div className="max-w-4xl mx-auto rounded-2xl border border-[#00f0ff] bg-[#111122]/80 shadow-xl shadow-[#00f0ff]/10 backdrop-blur-lg p-8">
        <h1 className="text-4xl font-bold text-[#00f0ff] mb-6 tracking-wide">
          Top Hypercasual Games Online
        </h1>

        <p className="text-lg leading-relaxed mb-6">
          Hypercasual games are perfect for players who love quick challenges, minimal controls, and high replayability. These games are easy to pick up and typically use simple tap or swipe mechanics, making them fun for everyone.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          Their appeal lies in their simplicity—start playing in seconds and enjoy short, addictive sessions. Games like <em>Flappy Bird</em>, <em>2048</em>, and <em>Stack</em> defined the genre with minimalist gameplay and endless replay value.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          Despite basic visuals, hypercasual games are often mentally engaging and satisfying. Many feature leaderboards or personal challenges that motivate players to return for "just one more try."
        </p>

        <p className="text-lg leading-relaxed mb-6">
          At <strong>BrowserArena</strong>, we curate only the most polished and engaging hypercasual games, optimized for performance across all devices. Whether you're on a phone, tablet, or laptop—you're always one click away from fun.
        </p>

        <div className="mt-8 text-center">
          <p className="text-base mb-4">
            Learn more about{" "}
            <Link to="/about-browser-games" className="text-[#00f0ff] underline hover:text-[#ff007f] transition">
              browser games
            </Link>{" "}
            or dive into our{" "}
            <Link to="/html5-games" className="text-[#00f0ff] underline hover:text-[#ff007f] transition">
              HTML5 games
            </Link>{" "}
            collection now.
          </p>

          <Link
            to="/games/hypercasual"
            className="inline-block mt-4 px-6 py-2 text-base font-semibold rounded-full border border-[#00f0ff] text-[#00f0ff] hover:bg-[#00f0ff]/10 hover:text-[#ff007f] transition"
          >
            🚀 Play Hypercasual Games
          </Link>
        </div>
      </div>
    </div>
  );
}
